<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1 class="title">공통 코드</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn mint" @click="goEdit('NEW')">+ 새 코드 추가</button>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.code_name" @keyup.enter="retrieve" placeholder="코드명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>

      <el-collapse-transition>
        <div v-show="show">
          <el-select v-model="search.parent_code" placeholder="선택" @change="changeCateSelectOpt">
            <el-option v-for="parent in parentCodeData" :label="parent.code_name" :value="parent.code_id" :key="parent.code_id"></el-option>
          </el-select>
        </div>
      </el-collapse-transition>
    </div>
    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      :page-size="emptyPageSize"
      :pagination-props="emptyPaginationProps"
      :action-col="actionCol"
      @row-click="rowClickHandler">
    </stone-data-table>

  </div>
</template>
<script>
import common from '@/modules/common'
export default {
  name: 'M990501',
  mixins: [common.mixins],
  data () {
    return {
      show: false,
      tableData: [],
      tableColumns: [
        // {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: '코드ID', prop: 'code_id', align: 'left', class: 'bold', width: 100},
        {label: '코드명', prop: 'code_name', align: 'left', width: 150},
        {label: '상위 메뉴', prop: 'parent_name', width: 100},
        {label: '참조 코드', prop: 'main_code', width: 80},
        {label: '정렬', prop: 'ordby', align: 'right', width: 80}
      ],
      actionCol: {
        label: '삭제',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.deleteMenu(row.code_id, row.parent_code)
          },
          props: {
            type: 'danger',
            size: 'mini'
          },
          label: '삭제'
        }]
      },
      search: {
        code_name: ''
      },
      parentCodeData: []
    }
  },
  beforeCreate () {
  },
  created () {
    // if (this.$route.params.isSearch) {
    //   this.$parent.$parent.getMenuAuth()
    // }
    this.getParentList()
  },
  mounted () {
  },
  methods: {
    changeCateSelectOpt (value) {
      this.search.parent_code = value
    },
    retrieve () {
      this.loadStoneDataTable('/code/listing', this.search)
        .then(response => {
          this.tableData = response.data
        })
    },
    goEdit (codeId, parentCode = 'TOP') {
      const param = {
        code_id: codeId,
        parent_code: parentCode
      }
      this.$router.push({name: 'M990502', params: param})
    },
    rowClickHandler (row, event, column) {
      if (column.label !== '삭제') {
        this.goEdit(row.code_id, row.parent_code)
      }
    },
    deleteMenu (codeId, parentCode) {
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        let param = {}
        param.code_id = codeId
        param.parent_code = parentCode
        common.axios.delete('/code', {data: param})
          .then(response => {
            this.$message('삭제되었습니다.')
            this.getParentList()
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    getParentList () {
      common.axios.get('/code/parent')
        .then(response => {
          response.data.unshift({
            'code_id': '',
            'code_name': 'ALL'
          })
          this.parentCodeData = response.data
          this.retrieve()
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990501.vue